<template>
  <div style="display: flex">
    <TimeResponseAlert
      :created="row.created_date"
      :meta-deadline="row.meta.deadline"
      :show-date="false"
      class="mr-2"
    />
    <b-tooltip :label="row.title" type="is-light">
      <b-navbar-item
        tag="router-link"
        :to="{
          path: constants.PATH_INFO.BASIC_INFO.path,
          query: { itinerary: row.id },
        }"
        class="color-secondary cursor quote__link"
        style="cursor: pointer"
      >
        <p class="has-one-line-ellipsis" style="width: 9rem; text-align: left">
          {{ row.title }}
        </p>
      </b-navbar-item>
    </b-tooltip>
  </div>
</template>

<script>
import TimeResponseAlert from "@/components/_shared/TimeResponseAlert.vue";
import { DATE_FORMAT_MMM_DD_YYYY } from "@/constants";
import { PATH_INFO } from "@/router/path";
import { DATA_TEST_ID_VALUES } from "@/constants/test";

export default {
  name: "QuoteTitleTableRow",
  components: { TimeResponseAlert },
  props: {
    row: Object,
  },
  data() {
    return {
      constants: { DATE_FORMAT_MMM_DD_YYYY, PATH_INFO, DATA_TEST_ID_VALUES },
    };
  },
};
</script>
